import React from 'react';
import Grid from '@mui/material/Grid';
import Person from '../images/2person.png';
import Back from '../images/back.png';
import { Box, Typography } from '@mui/material';
function wearehiring() {
    return (
        // <div className="centerweare">
        //     <div className="wearehiring">

        //     </div>
        // </div>
        <Grid container>
            <Grid item md={1} xs={0}></Grid>
            <Grid item md={10} className='wearehiring'>
                <Grid container spacing={2}>
                    <Grid item md={6}>
                        <Typography className="firstwe subHeading1Mid">How to find good employees?</Typography>
                        <Typography className="secondwe bannerTextMid">We're hiring now</Typography>
                        <Typography className="secondwe text1Mid">One stop location for work from home, remote, and flexible work opportunities</Typography>
                        <Typography className="firstwe"><button className="webtn" type="button">Apply Now &gt; </button></Typography>
                        <div className="number" >
                            <Box>
                                <Typography className="circlenumber bannerText2Bold">1M +</Typography>
                                <Typography className="circleinfo">Active Users</Typography>
                            </Box>
                            <Box>
                                <Typography className="circlenumber bannerText2Bold">9k +</Typography>
                                <Typography className="circleinfo">Top Coaches</Typography>
                            </Box>
                            <Box>
                                <Typography className="circlenumber bannerText2Bold">2M +</Typography>
                                <Typography className="circleinfo">Job Options</Typography>
                            </Box>
                        </div>
                    </Grid>
                    <Grid item md={6}>
                        <img className="person" src={Person} alt="Socailmedia" />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item md={1} xs={0}></Grid>
        </Grid>
    );
}

export default wearehiring;
